import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Form, Button, Card } from "react-bootstrap";
import Layout from "../layout";
import SuccessModalOrder from "../../component/ModalSuccessOrder";

const PabrikTransaksi = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    tanggalPenerimaan: "",
    beratTotalDiterima: "",
    catatanKualitas: "",
    evaluasiKualitas: "",
    catatanDariPenerima: "",
  });
  const [msg, setMsg] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setMsg("No token found, please login again.");
        return;
      }

      try {
        const response = await axios.get(
          `https://c-greenproject.org:8000/orderberlangsung`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response.data;
        setFormData({
          tanggalPenerimaan: data.tanggalPenerimaan
            ? new Date(data.tanggalPenerimaan).toISOString().slice(0, 16)
            : "",
          beratTotalDiterima: data.beratTotalDiterima || "",
          catatanKualitas: data.catatanKualitas || "",
          evaluasiKualitas: data.evaluasiKualitas || "",
          catatanDariPenerima: data.catatanDariPenerima || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response) {
          setMsg(
            `Error: ${error.response.data.message || error.response.statusText}`
          );
        } else {
          setMsg("Error fetching data.");
        }
      }
    };

    console.log("Order ID:", id);
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      setMsg("No token found, please login again.");
      return;
    }

    const formattedTanggal = formData.tanggalPenerimaan
      ? new Date(formData.tanggalPenerimaan).toISOString().split("T")[0] 
      : null;

    const requestData = {
      orderPemanenUuid: id,
      tanggalPenerimaan: formattedTanggal,
      beratTotalDiterima: parseFloat(formData.beratTotalDiterima),
      catatanKualitas: formData.catatanKualitas.trim(),
      evaluasiKualitas: formData.evaluasiKualitas.trim(),
      catatanDariPenerima: formData.catatanDariPenerima,
    };

    try {
      console.log("Data yang dikirim ke backend:", requestData);
      await axios.patch(
        `https://c-greenproject.org:8000/inputtransaksi/${id}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setShowModal(true);
    } catch (error) {
      if (error.response) {
        setMsg(
          `Error: ${error.response.data.message || error.response.statusText}`
        );
      } else {
        setMsg("Error updating data.");
      }
      console.error("Error updating data:", error);
      console.error("Response data:", error.response?.data);
      console.error("Response status:", error.response?.status);
    }
  };

  return (
    <Layout>
      <Container>
        <nav aria-label="breadcrumb pb-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/order">Order Aktif</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Update Order
            </li>
          </ol>
        </nav>
        <h2 className="my-4">
          <strong>Update Data Penerimaan Singkong</strong>
        </h2>
        <Card className="p-4 mb-3">
          <Form onSubmit={handleSubmit}>
            {msg && <p className="text-center text-danger">{msg}</p>}

            <Form.Group className="mb-3">
              <Form.Label>Tanggal Penerimaan</Form.Label>
              <Form.Control
                type="datetime-local"
                name="tanggalPenerimaan"
                value={formData.tanggalPenerimaan}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Berat Total Diterima (kg)</Form.Label>
              <Form.Control
                type="number"
                name="beratTotalDiterima"
                value={formData.beratTotalDiterima}
                onChange={handleChange}
                placeholder="Masukkan berat total diterima"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Catatan Kualitas</Form.Label>
              <Form.Control
                as="textarea"
                name="catatanKualitas"
                value={formData.catatanKualitas}
                onChange={handleChange}
                placeholder="Masukkan catatan kualitas"
                rows={3}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Evaluasi Kualitas</Form.Label>
              <Form.Control
                type="text"
                name="evaluasiKualitas"
                value={formData.evaluasiKualitas}
                onChange={handleChange}
                placeholder="Masukkan evaluasi kualitas"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Catatan Dari Penerima</Form.Label>
              <Form.Control
                type="text"
                name="catatanDariPenerima"
                value={formData.catatanDariPenerima}
                onChange={handleChange}
                placeholder="Masukkan catatan dari penerima"
              />
            </Form.Group>

            <Button variant="success" type="submit">
              Update
            </Button>
          </Form>
        </Card>
      </Container>
      <SuccessModalOrder
        show={showModal}
        onClose={() => setShowModal(false)}
        message="Data transaksi pabrik telah dicatat."
      />
    </Layout>
  );
};

export default PabrikTransaksi;
